import Link from 'next/link'

import { Categories } from '../../api/search.api'
import { useCurrentPath } from '../../hooks/use-current-path'

import { BlockIcon } from './assets/block-icon'

import cl from './style.module.scss'

export interface SearchCatsProps {
	items: Categories[]
	onClick?: () => void
}

export const SearchCategories = (props: SearchCatsProps) => {
	const { items, onClick = () => {} } = props
	const { withSalt } = useCurrentPath()
	return (
		<div className={cl.cats}>
			<h4 className={cl.title}>Категории</h4>
			{items?.map(item => (
				<Link
					prefetch={false}
					href={`/catalog/category/${item.id}?${withSalt}`}
					key={item.id}
					className={cl.item}
					onClick={onClick}>
					<BlockIcon />
					<p className={cl.label}>{item.name}</p>
				</Link>
			))}
		</div>
	)
}
